import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SetupResellerRewardEditPageRoutingModule } from './setup-reseller-reward-edit-routing.module';

import { SetupResellerRewardEditPage } from './setup-reseller-reward-edit.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SetupResellerRewardEditPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [SetupResellerRewardEditPage]
})
export class SetupResellerRewardEditPageModule {}
